<template>
    <div>
        <div v-if="showParcelas">
            <h1 id="descricao-parcelas" aria-label="Parcelas da dívida." tabindex="-1"></h1>
            <!-- <div class="text-center mb-3" aria-label="Escolher: colocar em dia, quitar ou pagar algumas.">
                <v-btn-toggle mandatory v-show="!todasParcelasObrigatorias">
                    <v-btn id="btnEmDia" aria-label="Colocar em dia" class="bg-azulSec-light acessibilidade"
                        style="font-size:12px" @click="emDia()">Colocar <br v-if="small"> em dia</v-btn>
                    <v-btn aria-label="Quitar" class="bg-verde-light acessibilidade" @click="quitar()">Quitar</v-btn>
                    <v-btn aria-label="pagar algumas" class="bg-roxo-light acessibilidade" style="font-size:12px"
                        @click="pagarAlgumas()">Pagar <br v-if="small"> algumas</v-btn>
                </v-btn-toggle>
            </div> -->
            <center-element aria-label="Lista de parcelas" role="presentation" class="contrasteExtra">
                <v-card class="contrasteExtra px-0 no-outline" style="min-width: 295px">
                    <blockquote class="text-center blockquote acessibilidade" v-if="items.length === 0">Não há parcelas em
                        aberto para esta dívida.</blockquote>
                    <v-list role="list" id="cardParcela" class="contrasteExtra" style="width: 100%">
                        <div role="listitem" v-for="(item, i) in items" :key="i">
                            <div role="group">
                                <v-list-tile class="tempParcela">
                                    <v-list-tile-action class="mr-3" style="min-width:30px">
                                        <v-btn class="cl-azul-dark mt-0" v-show="item.check" icon :disabled="item.disabled"
                                            @click="marcaDesmarcaPO(item, i)"><i class="fas fa-check-square"></i></v-btn>
                                        <v-btn class="cl-azul-dark mt-0" v-show="!item.check" icon :disabled="item.disabled"
                                            @click="marcaDesmarcaPO(item, i)">
                                            <i class="far fa-square"></i></v-btn>

                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <table role="grid" style="width: 100%;">
                                            <tbody>
                                                <tr role="row">
                                                    <td role="gridcell" :aria-label="'Valor ' + item.SaldoPrincipal + '.'"
                                                        class="text-left " style="font-size: 14px;border: none">
                                                        R${{ item.SaldoPrincipal | formataValor }}</td>
                                                    <td role="gridcell"
                                                        :aria-label="'Data ' + item.DataVencimento | formataData + '.'"
                                                        class="text-right " style="font-size: 14px;border: none ">
                                                        {{ item.DataVencimento | formataData }}</td>
                                                </tr>
                                                <tr role="row">
                                                    <td role="gridcell" :aria-label="'Parcela: ' + item.NumeroParcela + '.'"
                                                        class="" style="font-size: 14px;border: none">Parcela
                                                        {{ item.NumeroParcela }}</td>
                                                    <td role="gridcell" :aria-label="item.Atraso + ' dias de atraso.'"
                                                        class="text-right " style="font-size: 14px;border: none">
                                                        {{ item.Atraso }} dias</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider aria-hidden="true" class="borderWhite" v-if="i < items.length - 1"
                                    :key="`divider-${i}`"></v-divider>
                            </div>
                        </div>
                    </v-list>
                </v-card>
                <div class="mt-2">
                    <h5 class="acessibilidade">Total selecionado: R${{ computedTotalSelecionado | formataValor }}</h5>
                </div>
                <div aria-label="Botão a direita: Negociar." style="">
                    <v-btn @click="negociar()" class="right bg-verde-dark"
                        :disabled="parcelasAPagar.length === 0">Negociar</v-btn>
                </div>
            </center-element>
        </div>
        <div v-else>
            <div v-if="chaveNegociacao == undefined">
                <form>
                    <div :class="{ 'row col-md-12': !small }">
                        <div :class="{ 'col-md-6': !small }">
                            <div class="content">
                                <div class="form-group mb-0 pa-3">
                                    <h5 class="text-center colorLabel mb-2">Forma de pagamento</h5>
                                    <div class="text-center mb-3">
                                        <v-btn-toggle mandatory>
                                            <v-btn class="bg-azulSec-light" @click="clickFormaPgto(1)">Boleto</v-btn>
                                            <v-btn class="bg-verde-light" style="font-size:12px"
                                                v-show="divida.Produto.PermiteAcordoCartao"
                                                @click="clickFormaPgto(2)">Cartão <br v-if="small"> de crédito</v-btn>
                                            <!-- <v-btn class="bg-roxo-light" style="font-size:12px" @click="clickFormaPgto(3)">Cartão <br v-if="small"> de débito</v-btn> -->
                                        </v-btn-toggle>
                                    </div>
                                </div>
                            </div>
                            <div class="content">
                                <div class="form-group pa-3">
                                    <label id="label-atualizado" for="valor" class="colorLabel">Valor atualizado</label>
                                    <div class="input-group input-group-lg" style="width: 180px">
                                        <input aria-labelledby="label-atualizado" id="valor" class="form-control"
                                            type="text" v-model="vrAtualizado" v-money="money" disabled>
                                    </div>
                                </div>
                                <div class="form-group pa-3" v-if="items[0].PermiteEntrada">
                                    <label id="label-entrada" for="entrada" class="colorLabel">Entrada diferenciada</label>
                                    <div class="input-group input-group-lg" style="width: 180px">
                                        <input aria-labelledby="label-entrada" id="entrada" class="form-control" type="text"
                                            :disabled="formaPgt === 2" v-model="vrEntrada" v-money="boolMoney ? money : ''"
                                            @focus="clearMoneyEntrada()" @input="boolMoney = true">
                                    </div>
                                </div>

                            </div>
                            <div class="content">
                                <div class="form-group">
                                    <h6 class="colorLabel">Data do primeiro vencimento</h6>

                                    <v-menu v-model="menuData" :nudge-left="200" lazy transition="scale-transition" offset-x
                                        :disabled="formaPgt === 2" full-width max-width="290px" min-width="290px"
                                        tabindex="0">
                                        <template v-slot:activator="{ on }">
                                            <div class="input-group input-group-lg" v-on="on">
                                                <input class="form-control" type="text" v-model="dateFormat"
                                                    :disabled="formaPgt === 2" v-mask="'##/##/####'"
                                                    style="max-width: 170px" @focus="focoData()">
                                                <div class="input-group-append pointer">
                                                    <div class="input-group-text">
                                                        <i class="fas fa-calendar-day"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <div class="teste">
                                            <v-date-picker id="datePicker" tabindex="0" v-model="date" no-title
                                                @change="fnFormataData()" :min="dtAtual" :max="dtLimite"
                                                locale="pt-br"></v-date-picker>
                                        </div>
                                    </v-menu>
                                </div>
                            </div>
                            <!-- <div class="content">
                                <div class="form-group">
                                    <div role="radiogroup">
                                        <input id="check1" role="radio" type="radio" :value="1" v-model="tpParcela"
                                            @change="tipoParcela()" :aria-checked="tpParcela === 1 ? true : false">
                                        <label for="check1" class="pa-2 colorLabel">Consultar por quantidade de parcela</label>
                                        <br>
                                        <input id="check2" role="radio" type="radio" :value="2" v-model="tpParcela"
                                            @change="tipoParcela()" :aria-checked="tpParcela === 2 ? true : false">
                                        <label for="check2" class="pa-2 colorLabel"> Consultar por valor da parcela</label>
                                    </div>
                                </div>
                            </div> -->
                            <div class="content" v-show="tpParcela !== 0">
                                <div class="form-group pa-2" v-show="tpParcela === 2">
                                    <label for="SaldoPrincipal" class="colorLabel">Valor por parcela</label>
                                    <div class="input-group input-group-lg">
                                        <input id="SaldoPrincipal" class="form-control" type="text" v-model="SaldoPrincipal"
                                            v-money="money">
                                    </div>
                                </div>
                                <div class="form-group pa-2" v-show="tpParcela === 1">
                                    <label for="qtParcela" class="colorLabel">Quantidade de parcelas</label>
                                    <div class="input-group input-group-lg">
                                        <input id="qtParcela" v-mask="'###'" class="form-control" type="text"
                                            v-model="qtdParcelas">
                                    </div>
                                </div>
                            </div>
                            <div class="content">
                                <v-btn @click="voltarParcelas()">
                                    <i class="fas fa-arrow-left pr-2 corIconesToolbar"></i> Voltar
                                </v-btn>
                                <v-btn class="text-center bg-amarelo-light mb-2" @click="consultarForma(false)">
                                    <i class="fas fa-search mr-3"></i>
                                    Simular Negociação
                                </v-btn>
                            </div>
                        </div>
                        <div class=" mt-2" :class="{ 'col-md-6': !small }" v-show="showOpPagamento">
                            <div>
                                <v-card>
                                    <v-subheader id="header-list" tabindex="-1">Escolha a melhor opção:</v-subheader>
                                    <div role="list">
                                        <div role="listitem" v-for="(item, i) in listOpcoesPagamento" :key="i"
                                            v-bind:class="{ 'blue lighten-5': item == opcaoAcordo, 'contrast-bk-yellow': item == opcaoAcordo }">
                                            <div class="header-panel pointer" @click="escolheParcela(item)">
                                                <v-btn icon @click.stop="item.expand = !item.expand"><i
                                                        class="fas fa-info-circle " style="font-size: 1.5em"></i></v-btn>
                                                <div>
                                                    <h5>{{ item.DescricaoAcordo }}</h5>
                                                    <h6>Primeiro pagamento em: {{ item.DtPrimeiroPagamento }}</h6>
                                                </div>
                                                <input style="margin-left: auto" type="radio" :value="item"
                                                    v-model="opcaoAcordo">
                                            </div>
                                            <transition name="fade">
                                                <table v-show="item.expand" class="table table-contrast"
                                                    style="background-color: white">
                                                    <tbody>
                                                        <tr>
                                                            <td colspan="2">Devido</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Valor Principal</td>
                                                            <td class="text-right">{{ item.Devido.VrPrincipal }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Juros</td>
                                                            <td class="text-right">{{ item.Devido.VrJuros }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Moral</td>
                                                            <td class="text-right">{{ item.Devido.VrMora }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Multa</td>
                                                            <td class="text-right">{{ item.Devido.VrMulta }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Multa</td>
                                                            <td class="text-right">{{ item.Devido.VrIOF }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="2">Cobrado</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Valor Principal</td>
                                                            <td class="text-right">{{ item.Cobrado.VrPrincipal }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Juros</td>
                                                            <td class="text-right">{{ item.Cobrado.VrJuros }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Moral</td>
                                                            <td class="text-right">{{ item.Cobrado.VrMora }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Multa</td>
                                                            <td class="text-right">{{ item.Cobrado.VrMulta }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Multa</td>
                                                            <td class="text-right">{{ item.Cobrado.VrIOF }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </transition>
                                            <v-divider aria-hidden="true" class="borderWhite mt-0 mb-0"
                                                v-if="i < items.length - 1" :key="`divider-${i}`"></v-divider>
                                        </div>
                                    </div>
                                </v-card>
                                <center-element>
                                    <Cartao v-if="opcaoAcordo.credito" :card="card" style="max-width: 500px"></Cartao>
                                </center-element>
                                <v-btn class="my-3 " v-bind:class="{ 'myCenter': small, 'right': !small }" color="success"
                                    @click.stop="fecharAcordo()">
                                    Fechar acordo <i class="fas fa-check ml-2"></i>
                                </v-btn>

                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <DetalhesAcordo v-if="showDetalhesAcordo" :chave="chaveNegociacao" :divida="divida" :small="small"
                :acordoCredito="acordoCredito"></DetalhesAcordo>
        </div>
        <v-dialog v-model="activeDialog">
            <v-card>
                <h3 class="headline grey lighten-2 pa-3">
                    Deseja formalizar o acordo?
                    <v-btn class="right" aria-label="Fechar" icon @click="activeDialog = false" style="margin-top: -5px"><i
                            class="fas fa-times fa-2x" style="color: grey "></i></v-btn>
                </h3>
                <v-card-text>
                    <h5>Termo de acordo para prosseguir:</h5>
                    <center-element class="pt-3">
                        <div class=" scroll-y scroll-x style-teste" style="max-width: 900px">
                            <div role="document" id="termo"></div>
                        </div>
                    </center-element>
                    <v-divider></v-divider>
                    <div class="content-end">
                        <v-btn color="error" @click="activeDialog = false" small>Cancelar</v-btn>
                        <v-btn color="success" @click="formaPgt == 2 ? autorizacaoCredito() : formalizarAcordo()"
                            small>Concordar e prosseguir</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
/* eslint-disable */
import DetalhesAcordo from './DetalhesAcordo'
import Vuex from '@/vuex/store'
import bus from '@/service/bus'
import moment from 'moment'
import { postOpcoesAcordoPagSeguro, getParcelasPagSeguro, postFormalizaAcordoPagSeguro, postBaixaAcordoCartao } from '@/service/service_autoatendimento/autoatendimento'
import { postAutorizacao, postCaptura, postCancelamento } from '@/service/service_pagamento/pagamento'
import { getTermoAcordo } from '@/service/service_autoatendimento/documento'
import Cartao from './MyComponents/Cartao'
import CenterElement from './MyComponents/CenterElement.vue'
import { setTimeout } from 'timers';
export default {
    components: { Cartao, CenterElement, DetalhesAcordo },
    props: ['divida'],
    data() {
        return {
            todasParcelasObrigatorias: false,
            validarFormaCredito: false,
            tpParcela: 1,
            activeDialog: false,
            chaveDivida: '',
            date: new Date().toISOString().substr(0, 10),
            dateFormat: moment().format('DD/MM/YYYY'),
            formaPgt: 1,
            qtdParcelas: '',
            vrEntrada: '',
            SaldoPrincipal: 0,
            vrAtualizado: 0,
            valor: 0,
            menuData: false,
            showParcelas: true,
            showOpPagamento: false,
            items: [],
            totalSelecionado: 0,
            boolMoney: false,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$',
                suffix: '',
                precision: 2,
                masked: false /* doesn't work with directive */
            },
            moneyTeste: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 0,
                masked: false /* doesn't work with directive */
            },
            listOpcoesPagamento: [],
            opcaoAcordo: '',
            card: {
                cardName: "",
                cardNumber: "",
                cardMonth: "",
                cardYear: "",
                cardCvv: "",
                type: "",
                codType: 0,
                niceType: "",
                config: ''
            },
            dtAtual: moment().format('YYYY-MM-DD'),
            dtLimite: moment(this.divida.DtPrazoMaximo, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            expand: false,
            chaveNegociacao: undefined,
            showDetalhesAcordo: false,
            acordoCredito: false
        }
    },
    computed: {
        small() {
            return !Vuex.state.large
        },
        moneyEntrada() {
            if (this.boolMoney) return this.money
            else return ''
        },
        parcelasAPagar: function(){
            return this.items.filter(e=> e.check) 

        },
        computedTotalSelecionado () {
            console.log('computedTotalSelecionado', this.items)
            const somaSaldos = this.items
                .filter(item => item.check)
                .reduce((acc, item) => acc + item.SaldoPrincipal, 0);
                console.log(`A soma dos SaldoPrincipal dos itens com check true é: ${somaSaldos}`);
                return somaSaldos
        }
    },
    mounted() {
        window.fonte('negociacao')
        if (window.innerWidth >= 750) Vuex.commit('SET_TELA', true)
        window.onresize = () => {
            if (window.innerWidth >= 750) Vuex.commit('SET_TELA', true)
            else Vuex.commit('SET_TELA', false)
        }
        this.chaveNegociacao = undefined
        this.carregaParcelas()


    },
    watch: {
        menuData: function () {
            if (!this.menuData) {
                document.getElementById('check1').focus()
            }
        },

    },
    methods: {
        focoData() {
            this.menuData = true
            // console.log(picker)
            setTimeout(() => {
                let picker = document.getElementById('datePicker')
                picker.focus()
            }, 500)
        },
        tipoParcela() {
            this.qtdParcelas = 1
            this.SaldoPrincipal = 0
        },
        async carregaParcelas() {
            bus.$emit('load-in', { text: 'Buscando as parcelas' })
            this.totalSelecionado = 0
            let count = 0
            getParcelasPagSeguro(this.divida.ChaveDivida).then((response) => {
                this.items = response.data.Retorno.map((item, index) => {

                    item.disabled = item.Obrigatorio
                    item.check = true

                    if (item.Obrigatorio) { // se a parcela for obrigatória, insere na lista de parcelasAPagar
                        count++
                        item.check = true
                        //this.parcelasAPagar.push(item)
                        item.disabled = true
                        this.totalSelecionado += item.SaldoPrincipal
                        if (!item.PermiteSaltar) { // se a parcela não permite saltar, inclui a parcela anterior
                            if (index > 0) {
                                response.data.Retorno[index - 1].check = true
                                //this.parcelasAPagar.push(response.data.Retorno[index - 1])
                                this.totalSelecionado += item.SaldoPrincipal
                            }
                        }
                    }
                    return item
                })

                if (count == this.items.length) this.todasParcelasObrigatorias = true
                // setTimeout(() => {
                let d = document.getElementById('descricao-parcelas')
                d.focus()

                // },5000)
                this.emDia()
                this.eventos()
                bus.$emit('load-out')
            }).catch(() => {
                bus.$emit('load-out')
            })

        },
        negociar() {
            this.valor = Number((this.totalSelecionado * 100).toFixed('2'))
            this.vrEntrada = ''
            this.boolMoney = false
            this.formaPgt = 1
            this.qtdParcelas = 1
            this.SaldoPrincipal = ''
            Vuex.commit('SET_OP_ACORDO', [])
            setTimeout(() => {
                if (this.items[0].PermiteEntrada) document.getElementById('entrada').focus()
            }, 100)
            // this.consultarValorDevido()
            this.consultarForma(true)
        },
        clearMoneyEntrada() {
            this.vrEntrada = ''
            this.boolMoney = false
        },
        voltarParcelas() {
            this.showParcelas = true
            this.showOpPagamento = false
            this.listOpcoesPagamento = []
        },
        fnFormataData() {
            this.dateFormat = moment(this.date, 'YYYY-MM-DD').format('DD/MM/YYYY')
        },
        clickFormaPgto(num) {
            console.log('clickFormaPgto', num)
            if (num == 2) this.dateFormat = moment().format('DD/MM/YYYY')
            this.formaPgt = num

        },
        opAcordoIgual() {
            let opAcordos = Vuex.state.opAcordo

            let i = opAcordos.findIndex(item => {
                return this.qtdParcelas == item.qtdParcelas
                    && Number(this.vrEntrada.slice(2).replace('.', '').replace(',', '.')) == item.valorEntrada
                    && Number(this.SaldoPrincipal.slice(2).replace('.', '').replace(',', '.')) == item.SaldoPrincipalsDesejado
                    && Number(this.SaldoPrincipal.slice(2).replace('.', '').replace(',', '.')) == item.SaldoPrincipalsDesejado
                    && moment(this.dateFormat, 'DD/MM/YYYY').format('DDMMYYYY') == item.data
                    && item.acordoCartaoCredito == false
            })
            return (i >= 0)

        },
        marcaDesmarcaPO(parPO, parIndex) {
            if (parPO.Obrigatorio) {
                parPO.check = true;
                return;
            }
            let novoValor = !parPO.check
            if (!parPO.PermiteSaltar) {
                if (novoValor) {
                    //Marcou
                    //valida se a anterior está marcada
                    if (parIndex > 0) {
                        if (!this.items[parIndex - 1].check) {
                            this.$swal({
                                text: 'Não é permitido pular parcelas, marque as parcelas anteriores antes de selecionar esta parcela.',
                                type: 'warning'
                            })
                            return
                        }
                    }
                }
                else {
                    //Desmarcou
                    if (parIndex < this.items.length - 1) {
                        if (this.items[parIndex + 1].check) {
                            this.$swal({
                                text: 'Não é permitido pular parcelas, desmarques as parcelas posteriores antes de desmarcar esta parcela.',
                                type: 'warning'
                            })
                            return;
                        }

                    }
                }
            }
            parPO.check = novoValor
        },
        consultarForma(origemMounted) {

            if (this.opAcordoIgual()) {
                this.$swal({
                    text: 'Simulação já realizada. Mude algum parâmetro para pesquisar uma opção diferente.',
                    type: 'warning'
                })
                return
            }
            // this.opcaoAcordo = ''
            this.validarFormaCredito = false
            bus.$emit('close-alert')
            if (!origemMounted) {
                if (this.criticaObrigatorios()) {
                    return
                }

            }
            //data útil
            console.log('buscando dia util')
            this.dateFormat = this.diaUtil(this.dateFormat)

            bus.$emit('load-in', { text: 'Calculando valores' })
            if (this.vrEntrada == '') this.vrEntrada = '0,00'
            let obj = {
                chaveDivida: this.divida.ChaveDivida,
                qtdParcelas: this.qtdParcelas,
                parcelas: this.parcelasAPagar[0].NumeroParcela.toString(),
                valorEntrada: Number(this.vrEntrada.slice(2).replace('.', '').replace(',', '.')),
                SaldoPrincipalsDesejado: Number(this.SaldoPrincipal.slice(2).replace('.', '').replace(',', '.')),
                acordoCartaoCredito: false,
                data: moment(this.dateFormat, 'DD/MM/YYYY').format('DDMMYYYY'),
                dataAtual: moment(this.dateFormat, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }
            let payload = {
                Parcelas: this.parcelasAPagar.map(e => e.NumeroParcela)
            }
            postOpcoesAcordoPagSeguro(obj, payload).then(response => {
                let temp = JSON.parse(JSON.stringify(Vuex.state.opAcordo))
                temp.push(obj)
                Vuex.commit('SET_OP_ACORDO', temp)
                this.showParcelas = false
                if (origemMounted) {
                    let dados = response.data.Retorno
                    this.vrAtualizado = dados.Devido.ValorTotal
                }
                response.data.Retorno.expand = false
                this.listOpcoesPagamento.push(response.data.Retorno)
                this.listOpcoesPagamento[0].active = true
                this.opcaoAcordo = this.listOpcoesPagamento[0]
                this.showOpPagamento = true
                this.validarFormaCredito = true
                bus.$emit('load-out')
            }).catch((error) => {
                bus.$emit('load-out')
                console.log('erro na fn', error)
                if (error.response.status === 400) {
                    this.$swal({
                        type: 'error',
                        text: error.response.data.Message
                    })
                    return
                } else {
                    this.$swal({
                        type: 'error',
                        text: 'Erro nao identificado'
                    })
                }
            })
        },
        /*
        /*Localiza o dia útil para o primeiro vencimento
        */
        diaUtil(parData) {
            let dataUtil = moment(parData, 'DD/MM/YYYY').format('DD/MM/YYYY')
            //domingo ou sábado
            while (moment(dataUtil, 'DD/MM/YYYY').day() == 0 || moment(dataUtil, 'DD/MM/YYYY').day() == 6) {
                dataUtil = moment(dataUtil, 'DD/MM/YYYY').add(1, 'days')
            }
            return moment(dataUtil, 'DD/MM/YYYY').format('DD/MM/YYYY')
        },
        criticaObrigatorios() {
            let d = document.getElementById('header-list')
            let msgErro = ''
            d.focus()
            if ((isNaN(this.qtdParcelas) || this.qtdParcelas == 0) && this.SaldoPrincipal == 'R$0,00') {
                msgErro += '- Preencha o campo de valor por parcelas ou o campo de quantidade de parcelas.<p>'
            }
            this.date = moment(this.dateFormat, 'DD/MM/YYYY').format('YYYY-MM-DD')
            let atual = moment().format('YYYY-MM-DD') // para não considerar a hora na comparação
            if (this.date == 'Invalid date' || this.dateFormat.length != 10) {
                msgErro += '- Data não está correta.<p>'
            }
            if (moment(atual, 'YYYY-MM-DD').isAfter(moment(this.date, 'YYYY-MM-DD'))) {
                msgErro += '- A data deverá ser maior ou igual a hoje.'
            }
            if (msgErro != '') {
                bus.$emit('alert-danger', text)
                bus.$emit('load-out')
                return true
            }
            return false
        },
        errorFormaPagt() {
            this.$swal({
                text: 'Ops! Nestas condições não conseguimos realizar seu acordo. Por favor, altere a negociação e tente novamente!',
                type: 'warning'
            })
        },
        escolheParcela(item) {
            this.listOpcoesPagamento.forEach(e => e.active = false)
            item.active = !item.active
            console.log(item)
            if (item.active) this.opcaoAcordo = item
        },
        fecharAcordo() {
            if (this.divida.TermoAceite != 0) {
                let obj = {
                    chaveDivida: this.divida.ChaveDivida,
                    codigo: this.divida.TermoAceite
                }
                bus.$emit('load-in', { text: 'Carregando' })
                getTermoAcordo(obj).then(response => {
                    bus.$emit('load-out')
                    let d = document.getElementById('termo')
                    d.innerHTML = response.data.Retorno
                    this.activeDialog = true
                    setTimeout(() => {
                        let title = document.getElementById('titleDialog')
                        title.focus()
                    }, 500)
                }).catch(() => {
                    bus.$emit('load-out')
                })
            } else {
                this.$swal({
                    title: 'Formalizar o acordo?',
                    type: 'question',
                    allowEscapeKey: true,
                    showConfirmButton: true,
                    confirmButtonText: 'Sim',
                    showCloseButton: true
                }).then(result => {
                    console.log('no then', result.value, this.formaPgt)
                    if (result.value) {
                        this.formalizarAcordo()
                    }
                })
            }
        },
        formalizarAcordo() {
            try {
                let obj = {
                    chaveDivida: this.divida.ChaveDivida,
                    qtdParcelas: this.opcaoAcordo.RetornoSimulacao.QuantidadeParcelas,
                    dataAtual: moment(this.opcaoAcordo.RetornoSimulacao.DataPrimeiroVencimento, 'YYYY-MM-DD[T]HH:mm:ss').format('DD-MM-YYYY'),
                    parcelas: this.parcelasAPagar.map(e => e.NumeroParcela).join()
                }
                let payLoad = {
                    Parcelas: this.parcelasAPagar.map(e => e.NumeroParcela),
                    RetornoSimulacao: this.opcaoAcordo.RetornoSimulacao
                }
                console.log('this.opcaoAcordo.RetornoSimulacao', this.opcaoAcordo.RetornoSimulacao)
                bus.$emit('load-in', { text: 'Carregando' })
                postFormalizaAcordoPagSeguro(obj, payLoad).then((retorno) => {
                    bus.$emit('load-out')
                    Vuex.commit('SET_ACORDOS', []) // para carregar a lista atualizada quando a pessoa for em ACORDOS
                    Vuex.commit('SET_DIVIDAS', [])
                    this.chaveNegociacao = retorno.data.Retorno.chaveNegociacao
                    this.showDetalhesAcordo = true
                    this.opcaoAcordo = ''
                    this.activeDialog = false
                    this.$router.push({ name: 'acordos' })
                }).catch((error) => {
                    this.activeDialog = false
                    bus.$emit('load-out')
                    this.$swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: error.response.data.Message
                    })
                })
            } catch (error) {
                if (this.idAutho !== '') this.cancelaCredito()
                this.$swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: error.response.data.Message
                })
            }
        }
    }
}
</script>